// extracted by mini-css-extract-plugin
module.exports = {"progress":"App_progress__2NmV6","group":"App_group__1V81E","coin":"App_coin__3vUku"};